import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// actions
import list from "api/feed/list";
import formStyle from "assets/jss/views/feed/formStyle";
import Select from "react-select";
import {withStyles} from "@mui/styles";

NextFeed.propTypes = {
    retailerId: PropTypes.string.isRequired,
    actualNextFeed: PropTypes.string,
    actualFeed: PropTypes.string,
    formName: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

function NextFeed({retailerId, actualNextFeed, actualFeed, formName, onChange, ...props}) {
    const {classes} = props;
    const [feeds, setFeeds] = useState(null);
    const [selectedValue, setSelectedValue] = useState(null);

    useEffect(() => {
        if (!feeds) {
            list("pagination=false&draft=false&retailer.id=" + retailerId).then(response => {
                setFeeds(response);
            });
        }
    }, [feeds, retailerId]);

    if (feeds) {
        return (
            <div className={classes.fieldContainer}>
                <label
                    htmlFor={`${formName}_nextFeed`}
                    className={classes.fieldLabel}
                >
                    <FormattedMessage id={"feed.form.label.nextFeed"}/>
                </label>

                <Select
                    id={`${formName}_nextFeed_select`}
                    name={`nextFeed_select`}
                    options={[
                        { value: null, label: <FormattedMessage id={"feed.form.label.nextFeed.none"} /> },
                        ...feeds
                            .filter(feed => '/feeds/' + feed.id !== actualFeed)
                            .map(feed => ({
                                value: '/feeds/' + feed.id,
                                label: feed.name
                            }))
                    ]}
                    value={selectedValue || (actualNextFeed ? { value: actualNextFeed, label: feeds?.find(feed => '/feeds/' + feed.id === actualNextFeed)?.name } : null)}
                    onChange={(value) => {
                        setSelectedValue(value);
                        onChange(value);
                    }}
                    onBlurResetsInput={false}
                    placeholder={<FormattedMessage id={"feed.form.label.nextFeed"}/>}
                />
            </div>
        );
    }
}

export default NextFeed = withStyles(formStyle)(NextFeed);
